export default "__VITE_ASSET__CeGvA24p__"